




























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject, Ref } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';
import { SurveyQuestionEntity } from '@/entities/survey-question.entity';
import { SurveyQuestionPointEntity } from '@/entities/survey-question-point.entity';
import { UseService } from '@/services/service';
import SurveyQuestionPointService from '@/services/survey-question-point.service';
import { ValidationObserver } from 'vee-validate';
import * as _ from 'lodash';
import SurveyQuestionResultService from '@/services/survey-question-result.service';
import SurveyQuestionResultSuccessService from '@/services/survey-question-result-success.service';
import { SurveyQuestionResultSuccessEntity } from '@/entities/survey-question-result-success.entity';
import { SurveyQuestionResultEntity } from '@/entities/survey-question-result.entity';
import GraduationHatIcon from '@/components/Helper/Icon/Svg/GraduationHatIcon.vue';

@Component<SurveyQuestionTest>({
  filters: {
    filterNameQuestion(value: SurveyQuestionEntity, locale: String) {
      switch (locale) {
        case 'ja':
          return value.nameJa;
        case 'en':
          return value.nameEn;
        case 'vi':
          return value.nameVi;
        default:
          return value.nameEn;
      }
    },
    filterNameQuestionPoint(value: SurveyQuestionPointEntity, locale: String) {
      switch (locale) {
        case 'ja':
          return value.nameJa;
        case 'en':
          return value.nameEn;
        case 'vi':
          return value.nameVi;
        default:
          return value.nameJa;
      }
    },
  },
  components: { GraduationHatIcon },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class SurveyQuestionTest extends Vue {
  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => any;

  currentStaff!: StaffEntity;
  surveyQuestionPoints: Array<SurveyQuestionPointEntity> = [];
  surveyQuestionResults: Array<SurveyQuestionResultEntity> = [];
  surveyQuestionResultSuccess: SurveyQuestionResultSuccessEntity;

  @UseService(SurveyQuestionPointService)
  surveyQuestionPointService: SurveyQuestionPointService;

  @UseService(SurveyQuestionResultService)
  surveyQuestionResultService: SurveyQuestionResultService;

  @UseService(SurveyQuestionResultSuccessService)
  surveyQuestionResultSuccessService: SurveyQuestionResultSuccessService;

  @Ref('form') readonly form!: InstanceType<typeof ValidationObserver>;

  notifyId = 0;

  async created() {
    this.surveyQuestionResultSuccess = await this.surveyQuestionResultSuccessService.check();
    if (this.surveyQuestionResultSuccess.isSuccess) await this.$router.push('/e-learning');
    this.notifyId = this.surveyQuestionResultSuccess.notifyId;
    this.surveyQuestionPoints = await this.surveyQuestionPointService.getMany();
    this.surveyQuestionResults = _.shuffle(
      await this.surveyQuestionResultService.getMany(
        this.currentStaff.id,
        this.notifyId,
        this.currentStaff.companyId,
      ),
    );

    this.$cheeers.socket.on(
      'survey_question_result@updated',
      (instance: SurveyQuestionResultEntity) => {
        this.surveyQuestionResults = [...this.surveyQuestionResults].map((item) => {
          if (item.id === instance.id) return instance;
          return item;
        });
      },
    );
  }

  async save() {
    if (!(await this.checkValidate())) return;
    await this.surveyQuestionResultSuccessService.updateOne(this.surveyQuestionResultSuccess.id, {
      ...this.surveyQuestionResultSuccess,
      isSuccess: true,
    });
    await this.$cheeers.notify({
      text: this.$t('eLearning.sendSuccess'),
    });
    await this.$router.push('/e-learning');
  }

  async handleChangeRadio(value, index) {
    this.surveyQuestionResults[index].surveyQuestionPointId = value;
    await this.surveyQuestionResultService.updateOne(this.surveyQuestionResults[index].id, {
      ...this.surveyQuestionResults[index],
    });
  }

  async checkValidate() {
    const flag = await this.form.validate();
    if (!flag) {
      // eslint-disable-next-line no-restricted-syntax
      for (const key of Object.keys(this.form.errors)) {
        if (this.form.errors[key].length) {
          // eslint-disable-next-line no-await-in-loop
          await this.$cheeers.notify({
            text: this.form.errors[key][0],
            type: 'error',
          });
        }
      }
    }
    return flag;
  }

  get contentHeight() {
    return `calc(100vh - ${185}px)`;
  }
}
